import { ChangeEvent, ReactNode } from "react";
import "./style.scss";
interface Props {
	show: boolean;
	onClose: () => void;

	title?: string;
	subtitle?: string;
	children?: ReactNode;
	className?: string;
	block?: boolean;
	actions?: ReactNode;
}

const AppModal: React.FC<Props> = (props) => {
	const {
		show,
		onClose,
		title,
		subtitle,
		children,
		className,
		block,
		actions,
	} = props;

	const handleClose = () => {
		onClose();
	};

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {};

	return (
		<>
			<input
				type="checkbox"
				id="app-modal"
				className="modal-toggle"
				checked={show}
				onChange={handleChange}
			/>

			<div className={"modal app-modal " + className}>
				<div className="modal-box w-11/12 md:w-8/12 max-w-3xl">
					<div className="modal-header mb-5">
						{title && (
							<div className="">
								<h3 className="font-bold text-lg">{title}</h3>
								{subtitle && <div>{subtitle}</div>}
							</div>
						)}

						<button
							className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
							onClick={() => handleClose()}
						>
							✕
						</button>
					</div>

					<div className="modal-content">{children}</div>

					{actions && <div className="modal-actions">{actions}</div>}
				</div>

				{!block && (
					<label
						className="modal-backdrop"
						htmlFor="app-modal"
						onClick={() => handleClose()}
					>
						Close
					</label>
				)}
			</div>
		</>
	);
};
export default AppModal;
